import _extends from "@babel/runtime/helpers/esm/extends";
import { isDef } from '../../utils';
var defaultMinWidth = 0;
export function transformWidth(theWidth) {
  return typeof theWidth === 'number' ? theWidth : parseFloat(theWidth);
}
export function computeColumnWidth(mergedColumns, totalWidth) {
  // table父容器的宽度
  var TableContainerWidth = totalWidth; // table 所有列用户自定义宽度总和, 这里需要注意如果minWidth > width 以minWidth为准

  var TableColumnsTotalWidth = mergedColumns.reduce(function (acc, column) {
    return acc + (isDef(column.width) || isDef(column.minWidth) ? Math.max(isDef(column.width) ? transformWidth(column.width) : 0, isDef(column.minWidth) ? transformWidth(column.minWidth) : 0) : defaultMinWidth);
  }, 0); // 判断是否需要自动适配table容器的宽度

  var needResize = TableContainerWidth - TableColumnsTotalWidth > 0;

  if (!needResize) {
    return mergedColumns.reduce(function (pre, column) {
      var _extends2;

      return _extends({}, pre, (_extends2 = {}, _extends2[column.dataProp] = isDef(column.width) || isDef(column.minWidth) ? Math.max(isDef(column.width) ? transformWidth(column.width) : 0, isDef(column.minWidth) ? transformWidth(column.minWidth) : 0) : defaultMinWidth, _extends2));
    }, {});
  }

  var columnWidthDic = {};
  var columnTotalFixedWidth = 0; // has width props

  mergedColumns.forEach(function (column) {
    if (isDef(column.width)) {
      columnWidthDic[column.dataProp] = transformWidth(column.width);
      columnTotalFixedWidth += columnWidthDic[column.dataProp];
    }
  }); // 设置了minWidth的列数 未设置的列需要按照内部defaultMinWidth计算

  var unFixedColumns = mergedColumns.filter(function (column) {
    return !isDef(column.width);
  }); // 剩余需要分配的宽度

  var remainWidth = TableContainerWidth - columnTotalFixedWidth; // 模拟将待分配的宽度按照当前所有列进行比例分配，算出每列应当分配的宽度，
  // 如果小于当前列的最小宽度，则以最小宽度为准，最后得出需要调整的column，再按照比例进行分配

  var satifyAllCondition = false;

  var _loop = function _loop() {
    var columnAverageWidth = remainWidth / unFixedColumns.length;
    var longerColumn = void 0;
    var longerColumnWidth = 0;
    unFixedColumns.forEach(function (column) {
      if (isDef(column.minWidth)) {
        var value = transformWidth(column.minWidth);

        if (value > columnAverageWidth && value >= longerColumnWidth) {
          longerColumnWidth = value;
          longerColumn = column;
        }
      }
    });

    if (longerColumn) {
      remainWidth -= longerColumnWidth;
      unFixedColumns.splice(unFixedColumns.indexOf(longerColumn), 1);
      return "continue";
    }

    var shorterColumn = void 0;
    var shorterColumnWidth = 0;
    unFixedColumns.forEach(function (column) {
      if (isDef(column.maxWidth)) {
        var value = transformWidth(column.maxWidth);

        if (value < columnAverageWidth && value <= shorterColumnWidth) {
          shorterColumnWidth = value;
          shorterColumn = column;
        }
      }
    });

    if (shorterColumn) {
      remainWidth -= shorterColumnWidth;
      unFixedColumns.splice(unFixedColumns.indexOf(shorterColumn), 1);
      return "continue";
    }

    satifyAllCondition = true;
  };

  while (unFixedColumns.length && !satifyAllCondition) {
    var _ret = _loop();

    if (_ret === "continue") continue;
  }

  var columnAverageWidth = Math.floor(remainWidth / unFixedColumns.length);
  unFixedColumns.forEach(function (column, columnIndex) {
    if (columnIndex === unFixedColumns.length - 1) {
      columnWidthDic[column.dataProp] = Math.floor(remainWidth);
      return;
    }

    columnWidthDic[column.dataProp] = columnAverageWidth;
    remainWidth -= columnAverageWidth;
  });
  return columnWidthDic;
}